import React from 'react';

interface MapIconV2Props {
    width?: number;
    height?: number;
    color?: string;
}

const MapIconv2 = ({ width = 24, height = 24, color = '#B2B3B5' }: MapIconV2Props) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask
            id="mask0_1643_8218"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
        >
            <path d="M0 0H24V24H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1643_8218)">
            <path
                d="M17.075 8.16208H13.7838C13.6708 8.16208 13.5791 8.25367 13.5791 8.36645V10.6094"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.02148 12.637H7.61441C7.75128 12.637 7.8177 12.6729 7.87353 12.7445L14.1386 20.8828H16.699L10.5775 12.9317C10.4194 12.7273 10.4234 12.637 10.7356 12.637H23.6484L23.6444 10.6091H19.4097C19.2423 10.6091 19.1054 10.4724 19.1054 10.3052V4.6673M7.2942 10.6091H4.02148M17.0751 4.6673V10.3052C17.0751 10.4724 16.9382 10.6091 16.7708 10.6091H9.00162"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.01855 4.66699H7.17034"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.68945 18.8301V17.4538"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.68959 17.4531C7.29287 17.4531 7.7858 16.9621 7.7858 16.3595C7.7858 15.757 7.29287 15.2659 6.68959 15.2659C6.08635 15.2659 5.59473 15.757 5.59473 16.3595C5.59473 16.9621 6.08635 17.4531 6.68959 17.4531Z"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.12988 7.1377V5.7614"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.13006 5.76074C8.7333 5.76074 9.22492 5.26968 9.22492 4.66715C9.22492 4.06462 8.7333 3.57355 8.13006 3.57355C7.52678 3.57355 7.03516 4.06462 7.03516 4.66715C7.03516 5.26968 7.52678 5.76074 8.13006 5.76074Z"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5605 17.5361V16.1598"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5607 16.1592C17.1639 16.1592 17.6555 15.6681 17.6555 15.0656C17.6555 14.4631 17.1639 13.972 16.5607 13.972C15.9574 13.972 15.4658 14.4631 15.4658 15.0656C15.4658 15.6681 15.9574 16.1592 16.5607 16.1592Z"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.71625 20.8828H2.13473C1.15411 20.8828 0.351562 20.0812 0.351562 19.1018M0.351562 19.1018C0.351562 18.1223 1.15411 17.3206 2.13473 17.3206H3.41166C3.74517 17.3206 4.01892 17.0473 4.01892 16.7141V3.7237C4.01892 3.39061 3.74517 3.11719 3.41166 3.11719H2.13473C1.15411 3.11719 0.351562 3.9188 0.351562 4.89825V19.1018ZM9.22495 4.66735H22.8273C23.5462 4.66735 23.6445 5.13052 23.6445 5.44772V20.0095C23.6445 20.4488 23.5089 20.8828 22.7688 20.8828H8.235"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default MapIconv2;
